import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, } from '@mui/material'

interface AddSubCategoryModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
}

export default function AddSubCategory({ open, onClose, setOpen }: AddSubCategoryModalProps) {
    return (
        <Modal
            className="modal addCategory_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add SubCategory</h2>
                        <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>
                    </div>
                    <form className="form" action="">
                        <div className="control_group">
                            <label>SubCategory Name</label>
                            <TextField placeholder="Enter SubCategory Name" fullWidth hiddenLabel></TextField>
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal >
    )
} 